var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from 'antd';
import { LockKeyhole } from 'lucide-react';
import { FormSelect } from 'components/AntEnhancement/FormControls';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var CredentialsRoleForm = function (props) {
    var t = props.translate;
    var requirePassword = props.requirePassword !== false;
    var onChangeJobTitle = function (value) {
        var jobTitle = props.jobTitles.find(function (item) { return item.getId() === Number(value); });
        if (jobTitle) {
            props.employee.setJobTitle(jobTitle);
            var baseSalary = jobTitle.getBaseSalary();
            if (!Number.isNaN(baseSalary) && baseSalary > 0) {
                props.employee.setSalary(baseSalary);
            }
        }
    };
    var onChangePassword = function (event) {
        props.user.setPassword(event.target.value);
    };
    var onChangePasswordConfirmation = function (event) {
        props.user.setPasswordConfirmation(event.target.value);
    };
    var roleOptions = props.jobTitles.map(function (jobTitle) { return ({
        value: jobTitle.getId(),
        title: jobTitle.getTitle()
    }); });
    return (_jsxs("section", { className: "employee-form__section", children: [_jsxs("div", { className: "employee-form__section-head", children: [_jsx("span", { className: "employee-form__section-icon", "aria-hidden": true, children: _jsx(LockKeyhole, { size: 18, strokeWidth: 2 }) }), _jsx("h2", { className: "employee-form__section-title", children: t('credentialsRole') })] }), _jsxs("div", { className: "employee-form__grid employee-form__grid--3", children: [_jsxs("div", { className: "employee-form__field", children: [_jsxs("label", { className: "employee-form__label", htmlFor: "jobTitle", children: [t('role'), " ", _jsx("span", { className: "employee-form__req", children: "*" })] }), _jsx(FormSelect, { label: t('role'), name: "jobTitle", rules: [{ required: true, message: t('errors.jobTitle') }], placeHolder: t('rolePlaceholder'), onSelect: onChangeJobTitle, options: roleOptions })] }), _jsxs("div", { className: "employee-form__field", children: [_jsxs("label", { className: "employee-form__label", htmlFor: "password", children: [t('password'), requirePassword ? (_jsx("span", { className: "employee-form__req", children: " *" })) : (_jsxs("span", { className: "employee-form__optional", children: [" (", t('optional'), ")"] }))] }), _jsx(Form.Item, { name: "password", rules: __spreadArray(__spreadArray([], (requirePassword
                                    ? [{ required: true, message: t('errors.password.required') }]
                                    : []), true), [
                                    {
                                        validator: function (_, value) {
                                            if (!value)
                                                return Promise.resolve();
                                            if (String(value).length < 8) {
                                                return Promise.reject(new Error(t('errors.password.minLength')));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ], false), className: "form-item body---14pt-R", children: _jsx(Input.Password, { id: "password", placeholder: t('passwordPlaceholder'), onChange: onChangePassword }) }), requirePassword ? null : (_jsx("p", { className: "employee-form__help", children: t('passwordHelpEdit') }))] }), _jsxs("div", { className: "employee-form__field", children: [_jsxs("label", { className: "employee-form__label", htmlFor: "passwordConfirmation", children: [t('passwordConfirmation'), requirePassword ? (_jsx("span", { className: "employee-form__req", children: " *" })) : (_jsxs("span", { className: "employee-form__optional", children: [" (", t('optional'), ")"] }))] }), _jsx(Form.Item, { name: "passwordConfirmation", dependencies: ['password'], rules: __spreadArray(__spreadArray([], (requirePassword
                                    ? [
                                        {
                                            required: true,
                                            message: t('errors.passwordConfirmation.required')
                                        }
                                    ]
                                    : []), true), [
                                    function (_a) {
                                        var getFieldValue = _a.getFieldValue;
                                        return ({
                                            validator: function (_, value) {
                                                var password = getFieldValue('password');
                                                if (!requirePassword && !password && !value) {
                                                    return Promise.resolve();
                                                }
                                                if (!value || password !== value) {
                                                    return Promise.reject(new Error(!value
                                                        ? t('errors.passwordConfirmation.required')
                                                        : t('errors.passwordConfirmation.match')));
                                                }
                                                return Promise.resolve();
                                            }
                                        });
                                    }
                                ], false), className: "form-item body---14pt-R", children: _jsx(Input.Password, { id: "passwordConfirmation", placeholder: t('passwordPlaceholder'), onChange: onChangePasswordConfirmation }) })] })] })] }));
};
export default localeTranslator(CredentialsRoleForm, 'employeeForm');
